export const ID = '76081918-eaea-47d2-b144-d76139338e3c';

export const NAME = 'Placeholder';
